import { getItem, removeItem, setItem } from 'services/local-storage';
import settings from 'config';
import {
  IdentityProviderLoginResponse,
  LoginRequest,
  LoginSSORequest,
} from 'types/auth';

/**
 * Log in and store authentication info in local storage.
 */
const login = async ({
  email,
  password,
  loginChallenge,
}: LoginRequest): Promise<IdentityProviderLoginResponse> => {
  const response = await fetch(
    `${settings.authApiBaseUrl}/idp/login?login_challenge=${loginChallenge}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password,
      }),
    },
  );
  if (response.status >= 400) {
    throw new Error(response.statusText);
  }
  const authResponse = await response.json();

  setItem('access_token', authResponse.login_response.access_token);
  setItem('user_id', authResponse.login_response.user.id.toString());

  return authResponse as IdentityProviderLoginResponse;
};

const ssoLogin = async ({
  email,
  password,
  sso,
  sig,
  return_url,
}: LoginSSORequest): Promise<IdentityProviderLoginResponse> => {
  const response = await fetch(
    `${settings.authApiBaseUrl}/discourse/login?sso=${sso}&sig=${sig}&return_sso_url=${return_url}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password,
      }),
    },
  );
  if (response.status >= 400) {
    throw new Error(response.statusText);
  }
  const authResponse = await response.json();
  return authResponse as IdentityProviderLoginResponse;
};

const logout = () => {
  removeItem('access_token');
  removeItem('user_id');
};

const getAccessToken = () => getItem('access_token');
const getUserId = () => getItem('user_id');

export default { login, ssoLogin, logout, getAccessToken, getUserId };
